import { rootApi } from '../rootApi';

export const matnrIntegrationStatusReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getMatnrIntegrationStatusList: builder.mutation({
            query: (body) => ({
                url: 'v1/matnrintegrationstatus/getlist',
                method: 'POST',
                body,
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount ?? 0,
                    };
                }
                return { items: [], totalCount: 0 };
            },
            invalidatesTags: ['MatnrIntegrationStatusReport']
        }),
    })
});

export const { useGetMatnrIntegrationStatusListMutation } = matnrIntegrationStatusReportApi;